import { FETCH_POSTS, LOADING_SET } from "../actions/actionType";

const initialState = {
	posts: [],
	loading: false
};

//pure function
//function tidak memiliki side effect ke variable diluar fn itu
//diberikan parameter sama, hasil harus sama
export default function postReducers(state = initialState, action) {
	switch (action.type) {
		case FETCH_POSTS:
			return {
				...state,
				posts: action.payload,
			};
		case LOADING_SET:
			return {
				...state,
				loading: action.payload,
			};
		default:
			return {
				...state,
			};
	}
}
